import React, { useState, useEffect } from "react";
import {
  Container,
  Typography,
  MenuItem,
  Menu,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { Players } from "src/_mock/players";
import { useNavigate } from "react-router-dom";
import PlayersFilters from "src/components/players/PlayersFilters";
import PlayersTable from "src/components/players/PlayersTable";
import { get } from "src/utils/networkUtils";

const PlayersPage = () => {
  const inputStyles = {
    borderRadius: "50px",
    boxShadow: "0.5px 3px 10px 0px #7777771A",
    "& .MuiOutlinedInput-root": {
      borderRadius: "50px",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderRadius: "50px",
      borderColor: "#ccc",
    },
    "& .MuiInputBase-input": {
      color: "#6A707E",
      fontSize: "16px",
      fontWeight: 600,
    },
    "& .MuiInputBase-input::placeholder": {
      color: "#6A707E",
    },
    "& .MuiInputLabel-root": {
      color: "#6A707E",
      fontSize: "16px",
      fontWeight: 600,
    },
  };

  const [players, setPlayers] = useState([]);
  const [teams, setTeams] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedSport, setSelectedSport] = useState("");
  const [selectedLeague, setSelectedLeague] = useState("");
  const [selectedTeam, setSelectedTeam] = useState("");
  const [selectedPosition, setSelectedPosition] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [menuPlayerId, setMenuPlayerId] = useState(null);
  const navigate = useNavigate();

  console.log(teams)
  const handleMenuOpen = (event, playerId) => {
    setAnchorEl(event.currentTarget);
    setMenuPlayerId(playerId);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setMenuPlayerId(null);
  };

  const handleEdit = (playerId) => {
    navigate(`/dashboard/players/${playerId}`);
    handleMenuClose();
  };

  const handleAdd = () => {
    navigate("/dashboard/players/new");
  };

  const handleDelete = () => {
    handleMenuClose();
  };

  useEffect(() => {
    setPlayers(Players);

    // Fetch teams from API
    get("/admin/teams/1/scoreables?isInternational=false")
      .then((response) => {
        console.log("Teams data:", response);
        setTeams(response.scoreables || []);
      })
      .catch((error) => {
        console.error("Failed to fetch teams:", error);
      });
  }, []);

  const filteredPlayers = players.filter((player) => {
    return (
      (player.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        player.nickname.toLowerCase().includes(searchQuery.toLowerCase())) &&
      (selectedSport === "" || player.sport === selectedSport) &&
      (selectedLeague === "" || player.league === selectedLeague) &&
      (selectedTeam === "" || player.team === selectedTeam) &&
      (selectedPosition === "" || player.position === selectedPosition)
    );
  });

  const getUniqueValues = (key) => {
    const values = players.map((p) => p[key]).filter(Boolean);
    return [...new Set(values)];
  };

  return (
    <Container>
      <Typography
        variant="h4"
        gutterBottom
        sx={{
          mb: 5,
        }}
      >
        Players
      </Typography>

      <PlayersFilters
        inputStyles={inputStyles}
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        selectedSport={selectedSport}
        setSelectedSport={setSelectedSport}
        selectedLeague={selectedLeague}
        setSelectedLeague={setSelectedLeague}
        selectedTeam={selectedTeam}
        setSelectedTeam={setSelectedTeam}
        selectedPosition={selectedPosition}
        setSelectedPosition={setSelectedPosition}
        handleAdd={handleAdd}
        getUniqueValues={getUniqueValues}
      />

      <PlayersTable players={filteredPlayers} onMenuOpen={handleMenuOpen} />

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
      >
        <MenuItem onClick={() => handleEdit(menuPlayerId)}>
          <ListItemIcon>
            <EditIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Edit</ListItemText>
        </MenuItem>
        <MenuItem onClick={() => handleDelete(menuPlayerId)}>
          <ListItemIcon>
            <DeleteIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Delete</ListItemText>
        </MenuItem>
      </Menu>
    </Container>
  );
};

export default PlayersPage;
